import { render, staticRenderFns } from "./date.vue?vue&type=template&id=96974dbe&scoped=true&"
import script from "./date.vue?vue&type=script&lang=js&"
export * from "./date.vue?vue&type=script&lang=js&"
import style0 from "./date.vue?vue&type=style&index=0&id=96974dbe&scoped=true&lang=scss&"
import style1 from "./date.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96974dbe",
  null
  
)

export default component.exports